<template>
  <footer class="kiwi-footer">
    <section class="kiwi-footer-top py-8">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <article class="d-flex flex-column">
              <img src="@/assets/logo.svg" style="width: 151px;" alt="">
              <p class="kiwi-fs-16 mt-6">An exceptional practice platform for SAT & PTE featuring curated mock tests with AI-powered scoring.</p>
            </article>
          </v-col>
          <v-col cols="12" md="3" class="d-none d-md-block"></v-col>
          <v-col cols="12" sm="6" md="2">
            <article class="d-flex flex-column">
              <h6 class="kiwi-fs-15 font-weight-semi-bold text-uppercase mb-3" style="">Company</h6>
              <v-list
                :lines="false"
                density="compact"
                :ripple="false"
                variant="flat"
                class="justify-md-center d-flex flex-column"
              >
                <v-list-item
                  v-for="(item, i) in company"
                  :key="i"
                  :value="item"
                  :to="item.link"
                  class="px-0"
                >
                  <v-list-item-title v-text="item.title" class="kiwi-fs-14"></v-list-item-title>
                </v-list-item>
              </v-list>
            </article>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="overflow-hidden">
            <article class="d-flex flex-column">
              <h6 class="kiwi-fs-15 font-weight-semi-bold text-uppercase mb-3" style="">Resources</h6>
              <v-list
                :lines="false"
                density="compact"
                :ripple="false"
                variant="flat"
                class="justify-md-center d-flex flex-column"
                style=""
              >
                <v-list-item
                  v-for="(item, i) in support"
                  :key="i"
                  :value="item"
                  :to="item.link"
                  class="px-0"
                >
                  <v-list-item-title v-text="item.title" class="kiwi-fs-14"></v-list-item-title>
                </v-list-item>
              </v-list>
            </article>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <v-divider></v-divider>
    <section class="kiwi-footer-bottom">
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            Copyright &copy; 2025. All Rights Reserved.
          </v-col>
          <v-col cols="12" md="6" class="text-md-right">
            <template v-for="(link, LI) in copyrightLink" :key="LI">
              <router-link :to="link.link" :class="LI > 0 ? 'ml-2 ml-md-4' : ''" style="text-decoration: none; color: var(--color-black);">{{link.title}}</router-link>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </footer>
</template>

<script setup>
  import {ref, computed} from 'vue'
  import Intercom from '@intercom/messenger-js-sdk';
  import { useInstituteStore } from '@/stores/institute/institute-store'
  import { storeToRefs } from 'pinia';
  const store = useInstituteStore();
  const {configData} = storeToRefs(store)
  const enabled_features = computed(() => {
    return configData.value.institute.enabled_features
  })
    setTimeout(() => {
      if(enabled_features.value.includes('intercom-chat')) {
          Intercom({
            app_id: 'wgokdvuc',
          });
      }
    }, 500)
  
  const company = ref([]);
  company.value = [
    {
      title: 'Products',
      link: '/product'
    },
    {
      title: 'Features',
      link: '/feature'
    },
  ]
  
  const support = ref([]);
  support.value = [
    {
      title: 'Blog',
      link: '/blog'
    },
    {
      title: 'Pricing',
      link: '/pricing'
    },
  ]
  
  const copyrightLink = ref([]);
  copyrightLink.value = [
    {
      title: 'Privacy Policy',
      link: '/privacy'
    },
    {
      title: 'Terms of Service',
      link: '/terms-and-conditions'
    },
  ]

</script>

<style lang="scss" >
.v-list-item--nav .v-list-item-title.kiwi-fs-16 {
  font-size: 16px !important;
}

.kiwi-footer {
  .v-list-item::after, .v-list-item__overlay {
    display: none;
  }

}
</style>